module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABDCAMAAAAf1iN/AAAAMFBMVEX///////////////////////////////////////////////////////////////9Or7hAAAAAEHRSTlMAENCw/6Aw8NM9/PYf2fEgOKi27AAAAK9JREFUeNrt1rsOwkAMBVHbcSC8//9vQQRpWjRpvcV292iLLSYiM/TZ11nljX29dFd6oXuN0xnDCJWBoQUML2B4AcMLGF7A8AKGFzC8gOEFDC9geAHDCxhewPAChhcwvIDhBQwvYHgBwwsYXsDwAoYXMLyAgWANBG8gWGPbEKyB4M7l2n27HxGyeIUXHk9r8B+mYaZhpmGmYaZhpmGmYf4yFgRnrJ/bC/Fbvw4I3/UbF/YJsJZMiNUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close_w.png
// module id = Rtt7
// module chunks = 1